// ============================================
// RecentDeniedPanel - Events bị từ chối gần đây
// ============================================
//
// GET /atwork/access-denied/recent/ — chỉ event ACCESS_DENIED_*, mới nhất trước.

import { useI18n } from '../../../i18n';
import { useAtWorkRecentDenied } from '../../../hooks';

export function RecentDeniedPanel({ limit = 50 }: { limit?: number }) {
  const { t } = useI18n();
  const { data, isLoading, error } = useAtWorkRecentDenied({ limit });

  const events = data ?? [];

  return (
    <div className="overflow-hidden rounded-xl border border-slate-100 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4">
        <h3 className="text-base font-bold text-slate-900">{t('recentDeniedAccess')}</h3>
        {events.length > 0 && (
          <span className="rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-700">
            {events.length}
          </span>
        )}
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center p-10">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary-600" />
        </div>
      ) : error ? (
        <div className="p-10 text-center text-sm text-red-600">{t('failedToLoadDenied')}</div>
      ) : events.length === 0 ? (
        <div className="p-10 text-center text-slate-500">{t('noDeniedEvents')}</div>
      ) : (
        <ul className="max-h-[420px] divide-y divide-slate-100 overflow-y-auto">
          {events.map((e) => (
            <li key={e.id} className="flex items-start gap-3 px-6 py-3 hover:bg-slate-50">
              <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-red-500" />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-slate-800">
                  {e.person_name ?? t('unknownPerson')}
                </p>
                <p className="truncate text-xs text-slate-500">
                  {e.door_name ?? e.door_id}
                  {e.site_name ? ` · ${e.site_name}` : ''}
                </p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="max-w-[130px] truncate rounded bg-red-50 px-1.5 py-0.5 text-xs font-normal text-red-600 sm:max-w-none">
                  {e.event_type}
                </span>
                <span className="whitespace-nowrap text-xs text-slate-400">
                  {new Date(e.timestamp).toLocaleString()}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
